module.exports = __webpack_public_path__ + "static/media/expert_network_logo.9d6e8146.svg";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/expert_network_logo.svg
// module id = 483
// module chunks = 0